<template>
  <div class="display">
      <el-row>
        <el-col :span="10" class="dis-left">
          <h3 class="desc">Platform built by APP developer for developer, turning your APP into business.</h3>
          <h2 class="title">Gaming + Advertising <br> = Our DNA</h2>
          <h3>Our focus is to provide quality performing in-app inventory to our buyers and to bridge our app developers with global reputable brand advertisers in achieving high CPM and fillrate.</h3>
          <el-row class="link-jump">
            <el-col :span="12">
                <h4>For DSP/Advertisers</h4>
                <el-button @click="() => goAnchor('#Advertise')" type="primary">Advertise&nbsp;&nbsp;<i class="el-icon-arrow-right"></i></el-button>
            </el-col>
            <el-col :span="12">
              <h4>For Game/APP Developers</h4>
              <el-button @click="() => goAnchor('#Monetize')" type="primary">Monetize&nbsp;&nbsp;<i class="el-icon-arrow-right"></i></el-button>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="14" class="dis-right">
          <img src="~@images/home_bg.png" alt="" />
        </el-col>
      </el-row>
  </div>
</template>
<script>
export default {
  name: "Display",
  methods: {
    goAnchor(selector) {
        document.querySelector(selector).scrollIntoView();
    }
  }
};
</script>
<style lang="scss" scoped>
.display {
  position: relative;
  border-color: transparent;
  background: #fff;
  width: 100%;
  height: px2rem(603);
  margin-top: px2rem(60);
  overflow: hidden;
  box-shadow: $section-box-shadow;
  .el-row {
    height: 100%;
    .dis-left {
      margin: 0 auto;
      padding-left: px2rem(40);
      h2 {
        font-size: px2rem(36);
        color: $--color-primary;
        font-weight: 600;
        letter-spacing: 1px;
        text-align: left;
        margin-top: px2rem(30);
        line-height: 1.3em;
      }
      .desc {
        margin-top: px2rem(90);
      }
      h3 {
        margin: 0 auto;
        text-align: center;
        margin-top: px2rem(40);
        font-size: px2rem(17);
        line-height: px2rem(28);
        color: #aaa;
        line-height: 1.2em;
        text-align: left;
      }
      .link-jump {
        margin-top: px2rem(30);
        text-align: left;
        h4 {
          font-size: px2rem(16);
          height: px2rem(36);
          line-height: px2rem(36);
          color: $--color-primary;
          text-align: left;
          margin: 0 auto;
          white-space: nowrap;
        }
        .el-button{
          margin-top: px2rem(25);
          border-radius: 8px;
          font-size: px2rem(14);
          i {
            font-weight: bolder;
          }
        }
      }
    }
    .dis-right {
      display: flex;
      align-items: center;
      height: 100%;
      img {
        display: block;
        margin: auto;
        height: 88%;
      }
    }
  }
}
</style>